import React from 'react'
import { Button, Input, Spinner } from '@design-systems/canvas-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleDot } from '@fortawesome/free-regular-svg-icons'
import { ErrorBanner } from '../../../../globalComponents/RfiCommons'
import { useData } from '../context/DataContext'
import { useUi } from '../context/UiContext'
import { getRfiBannerErrorMessage } from '../../../../common/helper'

export default function ActionBar({
  isReadonly,
  isNonCompliant,
  cancelAndRedirect,
  submitRfiForm,
  renderInternalApprovalButtons,
}) {
  const { state: d } = useData()
  const { state: u } = useUi()

  const showBody =
    !u.loading.fetch && !u.fetchFailed && d.template && d.rfiObject

  return (
    <div className="hc8-pv-3x hc8-mt-none hc8-mv-none hc8-bg-base sticky-bottom row-centre width-autosave-panel">
      {u.loading.save && !u.saveFailed && (
        <Spinner size="sm" className="hc8-ml-6x" />
      )}

      {/* NOTE: match old behaviour – show Autosaved even in read-only */}
      {!u.saveFailed &&
        !u.fetchFailed &&
        !u.loading.fetch &&
        d.template &&
        d.rfiObject &&
        !isNonCompliant && (
          <div className="align-centre-left hc8-ml-6x">
            <div id="spotlight-autosave">
              <FontAwesomeIcon icon={faCircleDot} className="blinker" />
            </div>
            <Input.Label className="hc8-ml-2x hc8-mb-none hc8-fs-150 font-weight-500">
              Autosaved
            </Input.Label>
          </div>
        )}

      {!isReadonly ? (
        <div className="dock-right row-centre">
          {(d?.errorCache?.tab || []).length > 0 && (
            <ErrorBanner
              message={getRfiBannerErrorMessage(
                d?.errorCache?.tab,
                d?.template?.dynamic_sections?.tabs,
              )}
            />
          )}

          <Button
            className="button-back hc8-mr-3x section-button"
            data-testid="btn-action-cancel"
            variant="ghost"
            size="md"
            onClick={cancelAndRedirect}
          >
            Close
          </Button>

          {showBody && (
            <Button
              className="button-back hc8-mr-3x section-button"
              variant="primary"
              size="md"
              isDisabled={
                (d?.errorCache?.tab || []).length > 0 || isNonCompliant
              }
              onClick={() => submitRfiForm(false)}
            >
              {u.loading.submit && !u.submitFailed ? (
                <Spinner size="sm" />
              ) : (
                'Submit'
              )}
            </Button>
          )}
        </div>
      ) : (
        showBody && renderInternalApprovalButtons?.()
      )}
    </div>
  )
}
